var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86691 0.775956C10.0444 0.598447 10.0444 0.310648 9.86691 0.133139C9.68936 -0.0443795 9.40155 -0.0443795 9.224 0.133139L5 4.35717L0.775956 0.133139C0.598447 -0.0443795 0.310648 -0.0443795 0.133139 0.133139C-0.0443795 0.310648 -0.0443795 0.598447 0.133139 0.775956L4.35717 5L0.133139 9.224C-0.0443795 9.40155 -0.0443795 9.68936 0.133139 9.86691C0.310648 10.0444 0.598447 10.0444 0.775956 9.86691L5 5.64283L9.224 9.86691C9.40155 10.0444 9.68936 10.0444 9.86691 9.86691C10.0444 9.68936 10.0444 9.40155 9.86691 9.224L5.64283 5L9.86691 0.775956Z",
    fill: "#7F40A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3dd9fa7d0ed602210b2c23435996c70d.svg";
export { ForwardRef as ReactComponent };